/**
 * 多语言加载器
 * 以 zh-CN 为基线，目标语言仅在自身文件中写「差异键」，缺失命名空间/键自动回退中文。
 *
 * 新增语言：
 *   1) 在同级新建 ja.js / ko.js ... 导出 { member: {...}, privacy: {...} }（只写差异）；
 *   2) 在下方 localeMap 注册即可，无需改动调用方。
 */
import { flattenBrandCommon } from '../config/brands'
import zhCN from './zh-CN'
import zhTW from './zh-TW'
import en from './en'
import ru from './ru'
import ja from './ja'
import ko from './ko'
import th from './th'
import vi from './vi'
import id from './id'
import ms from './ms'
import de from './de'
import hi from './hi'
import fr from './fr'
import es from './es'
import pt from './pt'
import ar from './ar'

export const DEFAULT_LANG = 'zh-CN'

const localeMap = {
  'zh-CN': zhCN,
  'zh-TW': zhTW,
  'en': en,
  'ru': ru,
  'ja': ja,
  'ko': ko,
  th,
  vi,
  id,
  ms,
  de,
  hi,
  fr,
  es,
  pt,
  ar
  // 新增语言时务必在此注册，否则 getLocale 会回退到 zh-CN
}

/**
 * 判断某语言是否已注册（即存在独立语言文件）
 * 未注册的语言会被 getLocale 回退到 zh-CN，调用方可据此改用配置里的默认品牌名
 * @param {string} lang
 * @returns {boolean}
 */
export function hasLocale(lang) {
  return !!localeMap[lang]
}

/**
 * 取某语言的完整文案（按命名空间与 zh-CN 合并）
 * @param {string} lang     语言代码
 * @param {string} brandKey 品牌名（来自 URL 参数 appname），用于覆盖 common 里的公司主体信息；
 *                          不传或匹配不到品牌时，保持语言文件自带文案
 * @returns {object} { common, member, cancel, permission, privacy, user }
 */
export function getLocale(lang, brandKey) {
  const target = localeMap[lang] ? lang : DEFAULT_LANG
  const base = localeMap[DEFAULT_LANG]
  const over = localeMap[target]
  const result = {}
  const nsSet = new Set([...Object.keys(base), ...Object.keys(over)])
  nsSet.forEach(ns => {
    result[ns] = Object.assign({}, base[ns] || {}, over[ns] || {})
  })
  // 多公司：把选中品牌（qy / cm）的字段扁平到 common 顶层，供 {{common.xxx}} 使用
  result.common = flattenBrandCommon(result.common, brandKey)
  return result
}

export default getLocale
